import { faMagnifyingGlass } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "antd";
import React, { useState } from "react";

const SearchComponent = ({ onSearch, type, size }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchTerm?.trim());
    }
  };

  const clearSearch = () => {
    setSearchTerm("");
    if (onSearch) {
      onSearch("");
    }
  };
  const fetchCurrentDetails = () => {};

  return (
    <Input
      className={size ? "" : "max-h-8"}
      size={size}
      variant="filled"
      placeholder={`Search By ${type}'s Name`}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      onPressEnter={handleSearch}
      onClear={clearSearch}
      prefix={<FontAwesomeIcon icon={faMagnifyingGlass} />}
      allowClear
    />
  );
};

export default SearchComponent;
